import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

import { OptimUiSharedModule } from '../../shared/optimus-ui-shared.module';
@Component({
    selector: 'app-p500-component',
    templateUrl: '500.component.html',
    imports: [OptimUiSharedModule, CommonModule]
})
export class P500Component {

  constructor() { }

}
